import { useCallback } from 'react';
import type { JSX } from 'react';

import { Loader } from '@change-corgi/design-system-legacy/components/progressiveDisclosure';
import { Box } from '@change-corgi/design-system-legacy/layout';

import { LazyComponent } from 'src/app/shared/components/layout/lazy';

import type { PublishStep } from './Publish';

async function LoadPublishStep(): Promise<typeof PublishStep> {
	return (await import(/* webpackChunkName: "pages/start-a-petition-steps-publish" */ './Publish')).PublishStep;
}

export function PublishLoader(): JSX.Element {
	const loadComponent = useCallback(LoadPublishStep, []);

	return (
		<LazyComponent
			loadComponent={loadComponent}
			fallback={
				<Box margin="auto">
					<Loader />
				</Box>
			}
		/>
	);
}

export const preloadPublishStep = LoadPublishStep;
